import { css } from "@emotion/react"
import { BlankState } from "source/shared/components"

export default function EmptyState() {
  return (
    <BlankState.Root css={styles.root}>
      <BlankState.Icon symbol="general#podcast" />
      <BlankState.Content>
        <BlankState.Heading text="No podcast episodes yet" />
      </BlankState.Content>
    </BlankState.Root>
  )
}

const styles = {
  root: css`
    padding: 3rem;
  `,
}
